module.exports = __webpack_public_path__ + "static/img/book22.0e8617a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book22.jpg
// module id = 98H0
// module chunks = 1